import { render, staticRenderFns } from "./createTncCategory.vue?vue&type=template&id=75293d02&"
import script from "./createTncCategory.vue?vue&type=script&lang=js&"
export * from "./createTncCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports